import {useContext,useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import {FamilyContext} from '../contexts/FamilyContext'
import {domusApi} from '../services/domusApi'
const types=[['tasks','Tarefas','/tasks'],['events','Eventos','/calendar'],['shopping_items','Compras','/shopping'],['transactions','Transações','/finance'],['items','Inventário','/items-control'],['family_posts','Mural','/family-board']]
export default function AnalyticsDashboard(){
 const {family}=useContext(FamilyContext)
 const [data,setData]=useState(null)
 const [error,setError]=useState('')
 const [loading,setLoading]=useState(false)
 useEffect(()=>{
  let live=true
  if(!family?.id){setData(null);return}
  setLoading(true)
  Promise.all(types.map(([type])=>domusApi.records(family.id,type))).then(results=>{if(live){setData(Object.fromEntries(types.map(([type],i)=>[type,results[i].data||[]])));setError('')}}).catch(e=>{if(live)setError(e.message)}).finally(()=>{if(live)setLoading(false)})
  return()=>{live=false}
 },[family?.id])
 return <main className="max-w-5xl mx-auto p-4 sm:p-6 space-y-5">
  <h1 className="text-2xl font-bold">Estatísticas Familiares</h1>
  <p className="text-sm text-gray-600">Informações dos registos da família, atualizadas após aprovação do Master. Sem estimativas ou números demonstrativos.</p>
  {!family&&<p>Entre na sua família para consultar estatísticas.</p>}
  {error&&<p role="alert" className="text-red-700">{error}</p>}
  {loading&&<p>A carregar indicadores...</p>}
  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">{types.map(([type,title,path])=><Link to={path} key={type} className="bg-white border rounded-xl p-4"><strong>{title}</strong><p className="text-3xl font-bold mt-2">{data?.[type]?.length??'—'}</p><span className="text-sm text-green-700 underline">Abrir módulo</span></Link>)}</div>
  {data&&<section className="bg-white border rounded-xl p-4 space-y-2"><h2 className="font-bold">Indicadores de atividade</h2><p>Tarefas concluídas: <strong>{data.tasks.filter(r=>r.payload?.completed).length}</strong></p><p>Compras por concluir: <strong>{data.shopping_items.filter(r=>!r.payload?.completed).length}</strong></p><p>Eventos registados: <strong>{data.events.length}</strong></p></section>}
 </main>
}
